import type { FC } from 'react';

import { ApplePayButton } from '@/components/ApplePayExpressButton/components/ApplePayButton';
import { useApplePayExpressCheckout } from '@/components/ApplePayExpressButton/hooks/useApplePayExpressCheckout';
import { TermsConsentDialog } from '@/components/ApplePayExpressButton/TermsConsentDialog';
import type { ApiError, ApiErrorType } from '@/lib/types';

import { Loader } from '../Loader';

interface ApplePayExpressButtonProps {
  areBraceletSizeErrorsSet: () => boolean;
  errorHandler?: (
    errors: ApiError[],
    opts?: { errorType?: ApiErrorType },
  ) => void;
}

export const ApplePayExpressButton: FC<ApplePayExpressButtonProps> = ({
  areBraceletSizeErrorsSet,
  errorHandler,
}) => {
  const {
    buttonRef,
    isActivated,
    isAvailable,
    isExpressPaymentAllowed,
    isGatewayConfigLoading,
    isTermsOpen,
    onCancelConsent,
    onConfirmConsent,
    showNflMarketingOption,
  } = useApplePayExpressCheckout({
    areBraceletSizeErrorsSet,
    errorHandler,
  });

  if (!isActivated || !isExpressPaymentAllowed) {
    return null;
  }
  if (isGatewayConfigLoading) {
    return <Loader height={50} />;
  }

  return (
    <>
      <ApplePayButton ref={buttonRef} isAvailable={isAvailable} />
      {isTermsOpen && (
        <TermsConsentDialog
          isOpen={isTermsOpen}
          onCancel={onCancelConsent}
          onConfirm={onConfirmConsent}
          showNflMarketingOption={showNflMarketingOption}
        />
      )}
    </>
  );
};
